<template>
  <div class="asnwer-right">
    <div class="answer-right-time">
      答题卡
    </div>
    <div class="right-asheet">
      <ul>
        <li
          v-for="(item,index) in qList"
          :key="`analysnum${index}`"
          v-on:click="$emit('qListClick',index)"
        >
          <a href="javascript:;"
            :class="[{'asheet-state': item.answerStatus==2},{'asheet-error': item.answerStatus==1}]"
          >
            {{index + 1}}
          </a>
        </li>
      </ul>
      <a href="javascript:;" :class="btnClass" @click="$emit('toSub')">思路点拨</a>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    },
    props: {
      qList: Array,
      showAnalysis: Boolean
    },
    computed: {
      btnClass: function () {
        return this.$props.showAnalysis?'btn-toSub-bottm-act':'btn-toSub-bottm'
      },
      correct: function () {
        const rightArr = this.$props.qList.filter(Q=>{
          return Q.answerStatus == 2
        })
        return rightArr.length
      },
      error: function () {
        const rightArr = this.$props.qList.filter(Q=>{
          return Q.answerStatus == 1
        })
        return rightArr.length
      }
    },
    mounted: function () {
    //  console.log(this.$props.qList)
    }
  }
</script>

<style scoped>
.asnwer-right{
  width: 250px;
  float: right;
  min-height: 600px;
  background-color: #fff;
  border-radius: 6px;
}
.answer-right-time{
  margin-left: 20px;
  margin-right: 20px;
  width: 210px;
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 18px;
  color: #454545;
}
.right-time-icon{
  width: 16px;
  height: 16px;
  margin-top: 19px;
  float: left;
  margin-right: 10px;

}
.right-asheet{
  width: 210px;
  margin:0 auto;
  margin-top: 20px;
}
.right-asheet ul{
  margin:0;
  padding:0;
  overflow: hidden;
}
.right-asheet ul li{
  list-style-type: none;
  float: left;
  margin-right: 12.5px;
  margin-bottom: 12.5px;
}
.right-asheet ul li:nth-child(5n) {
  margin-right:0;
  }
.right-asheet ul li a{
  width: 30px;
  height: 30px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  text-decoration: none;
  color: #7f7f7f;
  float: left;
  font-size: 14px;
}
.right-asheet ul li a.asheet-state{
  background:#0AAC50;
  color: #fff;
  border:1px solid #0AAC50;
}
.right-asheet ul li a:hover{
  background:#009640;
  color: #fff;
  border:1px solid #009640;
}
.answer-radio-user{
  background-image: url(../../../assets/img/icon-option1.png);
  background-repeat: no-repeat;
  background-size: 16px;
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  margin-top:3px;
}
.answer-option ul li.answer-option-user{
  color:#0AAC50;
  cursor:pointer;
  background:#e1ffeb;
  border-radius: 6px;
}
.answer-radio-user{
  background-image: url(../../../assets/img/icon-option1.png);
  background-repeat: no-repeat;
  background-size: 16px;
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  margin-top:3px;
}
.answer-option ul li.answer-option-user{
  color:#0AAC50;
  cursor:pointer;
  background:#e1ffeb;
  border-radius: 6px;
}
.answer-radio-error{
  background-image: url(../../../assets/img/icon-option2.png);
  background-repeat: no-repeat;
  background-size: 16px;
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  margin-top:3px;
}
.answer-option ul li.answer-option-error{
  color:#ff3a3a;
  cursor:pointer;
  background:#FFE5E5;
  border-radius: 6px;
}
.answer-analysis{
  margin-left: 20px;
  margin-right: 20px;
}
.answer-analysis-title{
  color: #252525;
  font-weight: bold;
  margin-top: 30px;
}
.answer-correct{
  color: #0AAC50;
  margin-left: 6px;
}
.answer-error{
  color: #FF3A3A;
  margin-left: 6px;
}
.answer-analysis-text{
  color: #252525;
  line-height: 1.7;
  margin-top: 10px;
}
.right-asheet ul li a.asheet-error{
  background:#FF3A3A;
  color: #fff;
  border:1px solid #FF3A3A;
}
.right-asheet ul li a:hover.asheet-error{
  background:#ff2a2a;
  color: #fff;
  border:1px solid #ff2a2a;
}
.btn-toSub-bottm{
 display: block;
 width: 100px;
 height: 32px;
 border-radius: 4px;
 border: 1px solid #0AAC50;
 color: #0AAC50;
 text-align: center;
 line-height: 32px;
 text-decoration: none;
 margin: 30px auto;

}
.btn-toSub-bottm-act{
 display: block;
 width: 100px;
 height: 32px;
 border-radius: 4px;
 border: 1px solid #0AAC50;
 text-align: center;
 line-height: 32px;
 text-decoration: none;
 margin: 30px auto;
 background:#0AAC50;
 color: #fff;
 }
</style>



// WEBPACK FOOTER //
// src/components/SpecialEx/children/qList.vue